const ABBREVIATIONS = [{
  suffix: 'mn',
  divisor: 1000000,
}, {
  suffix: 'bn',
  divisor: 1000000000,
}, {
  suffix: 'tn',
  divisor: 1000000000000,
}];

function hasNoDecimals(value) {
  return !(value % 1);
}

function getNumberOfInts(value) {
  // return Math.abs(Math.floor(value)).toString().length;
  return Math.floor(value).toString().length;
}

function getNumberOfDecimals(value, maxDecimals) {
  if (hasNoDecimals(value)) {
    return 0;
  }

  const valueStr = value.toString();
  if (valueStr.indexOf(getDecimalSeparator()) > 0) {
    const decimalsCount = valueStr.length - valueStr.indexOf(getDecimalSeparator()) - 1;
    return (decimalsCount > maxDecimals ? maxDecimals : decimalsCount);
  }

  // const digits = (value * (Math.pow(10, maxDecimals))).toString().split('').reverse();
  // let count = 1;
  // let i = 0;

  // for (; i < digits.length; i++) {
  //   if (!parseInt(digits[i], 10)) {
  //     count++;
  //   } else {
  //     break;
  //   }
  // }

  // return (maxDecimals + 1) - count;
}

function getNumberOfDigits(value, maxDecimals) {
  return getNumberOfInts(value) + getNumberOfDecimals(value, maxDecimals);
}

function getAbbreviatedString(value, maxDigits, maxDecimals, locale = 'en-GB', showSymbol = true) {
  const maxAbbrevDigits = maxDigits - 3;

  let abbreviatedNumber = value;
  let abbreviatedStringSuffix = '';

  for (const { divisor, suffix } of ABBREVIATIONS) {
    const valueInSuffix = value / divisor;
    if (getNumberOfInts(valueInSuffix) <= maxAbbrevDigits) {
      abbreviatedNumber = valueInSuffix;
      abbreviatedStringSuffix = suffix;
      break;
    }
  }

  const numberOfDigits = getNumberOfDigits(abbreviatedNumber, maxDecimals);
  const precision = Math.min(numberOfDigits, maxAbbrevDigits);
  const abbreviatedString =
    new Intl.NumberFormat(locale).format(abbreviatedNumber.toPrecision(precision));
  const symbol = getSymbol(showSymbol);
  return `${abbreviatedString}${abbreviatedStringSuffix}${symbol}`;
}

function abbrevNumber(value, maxDigits, maxDecimals, locale, showSymbol, maxDigitsIncludeDecimals) {
  if (typeof value == 'string' && !isNaN(value)) {
    value = parseFloat(value);
  }

  const numberOfInts = getNumberOfInts(value);
  const numberOfDecimals = getNumberOfDecimals(value, maxDecimals);
  const numberOfDigits = numberOfInts + numberOfDecimals;
  const symbol = getSymbol(showSymbol);

  if (maxDigitsIncludeDecimals) {
    if (numberOfDigits < maxDigits) {
      return value;
    }

    if (numberOfInts === maxDigits) {
      return Math.floor(value);
    }

    if (numberOfDigits > maxDigits && numberOfInts <= maxDigits) {
      const decimalsAllowed = maxDigits - numberOfInts;
      const valueStr = value.toString();
      const truncateDecimals = numberOfDecimals - decimalsAllowed;
      return valueStr.substr(0, valueStr.length - truncateDecimals) + symbol;
    }
  } else {
    if (numberOfInts <= maxDigits) {
      return value;
    }
  }

  if (numberOfDigits > maxDigits && numberOfInts > maxDigits) {
    return getAbbreviatedString(value, maxDigits, maxDecimals, locale, showSymbol);
  }

  return value;
}

function getSymbol(showSymbol) {
  return showSymbol ? '*' : '';
}

function getDecimalSeparator() {
  var n = 1.1;
  n = n.toLocaleString().substring(1, 2);
  return n;
}

function shouldAbbreviateNumber(value, maxDigits, maxDecimals, maxDigitsIncludeDecimals) {
  const numberOfDigits = getNumberOfDigits(value, maxDecimals);
  const numberOfInts = getNumberOfInts(value);

  if (maxDigitsIncludeDecimals) {
    return numberOfDigits > maxDigits; 
  } else {
    return numberOfInts > maxDigits;
  }
}

function shouldTruncateNumber(value, maxDigits, maxDecimals, maxDigitsIncludeDecimals) {
  const numberOfDigits = getNumberOfDigits(value, maxDecimals);
  const numberOfInts = getNumberOfInts(value);

  if (maxDigitsIncludeDecimals) {
    return numberOfDigits > numberOfInts && numberOfInts === maxDigits;
  } else {
    return numberOfInts > maxDigits;
  }
}

export default abbrevNumber;
export {
  shouldTruncateNumber,
  shouldAbbreviateNumber,
};
